export default {
    app: {
        name:              'NMR portal',
        institution:       'National Institute of Chemistry',
        version:           'Version 1.0.0',
        about:             'About',
        label_name:        'Application',
        label_institution: 'Institution',
        label_version:     'Version',
    },
    general: {
        add:          'Add',
        edit:         'Edit',
        cancel:       'Cancel',
        save:         'Save',
        delete:       'Delete',
        close:        'Close',
        confirm:      'Confirm',
        back:         'Back',
        next:         'Next',
        search:       'Search',
        search_hint:  'Search …',
        actions:      'Actions',
        yes:          'Yes',
        no:           'No',
        all:          'All',
        none:         'None',
        loading:      'Loading …',
        name:         'Name',
        email:        'E-mail',
        phone:        'Phone',
        password:     'Password',
        color:        'Color',
        description:  'Description',
        status:       'Status',
        today:        'Today',
        from:         'From',
        to:           'To',
        date:         'Date',
        time:         'Time',
        of:           'of',
        more:         'more',
        info:         'Information',
        details:      'Details',
        remove:       'Remove',
        select:       'Select',
        optional:     'optional',
        no_data:      'No data',
        access_denied: 'Access denied',
        access_denied_desc: 'You do not have permission to view this page.',
        not_found:    'Page not found',
        not_found_desc: 'The requested page could not be found.',
        go_home:      'Back to dashboard',
        light:        'Light theme',
        dark:         'Dark theme',
    },
    nav: {
        management:   'Management',
        personal:     'Personal',
        dashboard:    'Dashboard',
        reservations: 'Reservations',
        devices:      'Devices',
        probes:       'Probes',
        users:        'Users',
        groups:       'Groups',
        clients:      'Clients',
        quotas:       'Quotas',
        reports:      'Reports',
        downtimes:    'Downtimes',
        confirmations: 'Confirmations',
        probe_plan:   'Probe changes',
        notifications: 'Notifications',
        settings:     'Settings',
        profile:      'Profile',
    },
    errors: {
        generic_error:      'An error occurred',
        invalid_data:       'Invalid data',
        not_found:          'Not found',
        unauthorized:       'Unauthorized access',
        forbidden:          'You do not have permission for this action',
        internal:           'Server error',
        failed_to_insert:   'Failed to save',
        slot_occupied:      'This slot is already taken. Choose another slot.',
        quota_exceeded:     'The group does not have enough quota for this device in this period.',
        email_in_use:       'E-mail is already in use.',
        has_reservations:   'Cannot delete: there are upcoming reservations.',
        already_resolved:   'The request has already been handled.',
        wrong_old_password: 'The old password is incorrect.',
        in_use:             'Cannot delete: the item is in use.',
        on_add:             'Error while adding',
        on_edit:            'Error while updating',
        on_delete:          'Error while deleting',
        login_failed:       'Incorrect e-mail or password',
    },
    success: {
        add:       'Successfully added',
        edit:      'Successfully updated',
        delete:    'Successfully deleted',
        saved:     'Successfully saved',
    },
    validation: {
        required:      'This field is required',
        time_order:    'End must be after start',
        email:         'Invalid e-mail address',
        min_password:  'Password must be at least 6 characters',
        password_match: 'Passwords do not match',
        min1:          'Value must be at least 1',
        max_length:    'At most {n} characters',
    },
    login: {
        demo_user_plain: 'User (no reports)',
        demo_user_reports: 'User (with reports)',
        title:       'Sign in',
        subtitle:    'Sign in to the NMR portal',
        remember:    'Remember me',
        forgot:      'Forgot password?',
        submit:      'Sign in',
        demo:        'Quick login (demo)',
        forgot_stub: 'To reset your password, contact the system administrator.',
    },
    role: {
        reporter: 'Analyst',
        super_admin: 'Super administrator',
        probe_admin: 'Probe administrator',
        user:        'User',
    },
    dashboard: {
        greeting_morning:   'Good morning',
        greeting_day:       'Good day',
        greeting_evening:   'Good evening',
        new_reservation:    'New reservation',
        my_upcoming:        'My upcoming reservations',
        this_week:          'This week',
        pending:            'Awaiting confirmation',
        upcoming:           'Upcoming reservations',
        no_upcoming:        'No upcoming reservations',
        recent:             'Past reservations',
        recent_hint:        'Showing reservations you can still edit ({n} days after they end)',
        no_recent_editable: 'No past reservations you can still edit (window: {n} days after the end).',
        older:              'Older reservations',
        no_older:           'No older reservations',
        show_older:         'Show older reservations',
        load_more:          'Load more',
        hide_older:         'Hide older',
        pending_user:       'Awaiting administrator approval',
        quota_used_short:   'used',
        quota_free_of:      'free of {n}',
        quota_free_short:   '{free} free / {allocated}',
        quota_used_n:       '{n} used',
        quota_reserved_n:   '{n} reserved',
        quota_period:       'Period {from} – {to} · renews {renews} ({renewal})',
        quota_period_short: '{renewal}: {from} – {to} (renews {renews})',
        quota_no_renewal:   'This quota does not renew',
        quota_explain:      'A quota is deducted as soon as you book (“reserved”); once the slot is over it counts as “used”. Cancelling gives it back. Quotas refill when they renew.',
        my_quotas:          'My quotas',
        no_quotas:          'No allocated quotas',
        active_devices:     'Active devices',
        week_reservations:  'Reservations this week',
        users:              'Users',
        groups:             'groups',
        device_utilization_hint: 'Booked hours this week ({from} – {to})',
        device_utilization_week: 'Booked hours in the week {from} – {to}',
        week_prev:          'Previous week',
        week_next:          'Next week',
        reservations_n:     '{n} res.',
        device_utilization: 'Device utilization',
        probe_changes:      'Upcoming probe changes',
        probe_changes_all:  'All changes',
    },
    reservation: {
        title:            'Reservations',
        subtitle_user:    'Your NMR device reservations',
        subtitle_admin:   'All reservations in the system',
        tab_list:         'List',
        tab_calendar:     'Calendar',
        filter_device:    'Device',
        filter_group:     'Group',
        filter_status:    'Status',
        all_devices:      'All devices',
        all_groups:       'All groups',
        all_statuses:     'All statuses',
        col_date:         'Date',
        col_time:         'Time',
        col_operator:     'Operator',
        col_group:        'Group',
        col_device:       'Device',
        col_project:      'Project',
        col_probe:        'Desired probe',
        col_status:       'Status',
        col_note:         'Notes',
        detail_title:     'Reservation details',
        cancel_reservation: 'Cancel slot',
        confirm_cancel:   'Do you really want to cancel this slot?',
        cancel_title:     'Cancel slot',
        cancel_reason:    'Cancellation reason',
        cancel_reason_placeholder: 'Optional — the reason is included in the notification sent to the user.',
        cancelled_toast:  'Slot cancelled',
        edit_title:       'Edit reservation',
        edit_reservation: 'Edit reservation',
        saved_toast:      'Reservation updated',
        span_hint:        'The reservation spans several days — the nights in between are free.',
        start_time:       'Start',
        end_time:         'End',
        note:             'Notes',
        note_placeholder: 'Optional note for this slot …',
        feedback:         'Send feedback',
        feedback_title:   'Feedback about this slot',
        feedback_intro:   'Let the admins know about any problems while working with the spectrometer in this slot.',
        feedback_message: 'Message',
        feedback_placeholder: 'Describe the problem or observation …',
        feedback_sent:    'Feedback sent',
        feedback_sent_mark: 'Feedback sent',
        operator:         'Operator',
        current_probe:    'Current probe',
        no_reservations:  'No reservations',
        view_day:         'Day',
        view_week:        'Week',
        view_month:       'Month',
        column_devices:   'Devices',
        column_groups:    'Groups',
        column_view:      'View',
        legend_confirmed: 'Confirmed',
        legend_pending:   'Awaiting confirmation (striped)',
        legend_overnight: 'Overnight slot (device held until morning)',
        cal_overnight_until: 'night until {time}',
        cal_continued_from:  'from {time}',
        cal_continues_until: 'until {time}',
        cal_until_short:     'until {time}',
        past_edit_title:  'This reservation has already started',
        past_edit_notice: 'Time, device and probe can no longer be changed. You can correct the group, project and note until {deadline}.',
        legend_now:       'Now',
        legend_mine:      'My reservations',
        legend_others:    'Other users',
        legend_devices:   'Color = device',
        status: {
            confirmed: 'Confirmed',
            pending:   'Awaiting confirmation',
            cancelled: 'Cancelled',
        },
    },
    wizard: {
        no_groups_title: 'You are not a member of any group',
        no_groups_desc: 'Every reservation must belong to a research group. Ask an administrator to add you to one.',
        title:            'New reservation',
        step_data:        'Data',
        step_slot:        'Slot',
        step_probe:       'Probe',
        step_review:      'Review',
        operator:         'Operator',
        group:            'Research group',
        group_placeholder: 'Select a group',
        project:          'Project / client',
        project_placeholder: 'Internal (no project)',
        project_manual:   'Enter manually …',
        project_custom:   'Project / client name',
        project_custom_placeholder: 'E.g. ARRS project J1-1234',
        note:             'Notes',
        note_placeholder: 'Optional note for this slot …',
        device:           'Device',
        device_interval:  'Interval: {min} min',
        select_date:      'Select a date',
        slot_help:        'Click the start slot, then click the end slot to select a range of consecutive free slots.',
        last_free:        'Last free slot',
        quota_available:  'The group has {remaining} of {allocated} quota for device {device} (renewal {renewal})',
        quota_none:       'No quota is allocated for this group and device.',
        quota_window:     'The selected date falls in the period {period}.',
        quota_over:       'The selected slot exceeds the group\'s available quota for this period. Shorten the slot or pick another date.',
        slot_uses:        'This slot uses {n} quota',
        slot_uses_partial: 'At least {n} quota (partial)',
        legend_quota:     'Counts toward quota',
        multi_day:        'Multi-day reservation',
        multi_day_hint:   'Pick the start day and slot on the left, the end day and slot on the right. Nights in between are free.',
        start_day:        'Start day',
        end_day:          'End day',
        span_conflict:    'The selected period contains occupied or closed slots — pick another period.',
        span_preview_limited: 'The period is longer than {days} days — the quota cost cannot be previewed and will be validated by the server.',
        overnight_title:  'Overnight slot',
        overnight_short:  'until {time}',
        overnight_notice: 'The last slot of the day is the overnight slot — whoever books it may use the device until {time} the next day.',
        legend_free:      'Outside quota',
        window_notice:    'The selected date is outside this device\'s free reservation window ({days} days), so the reservation will await admin confirmation. It is confirmed automatically once the date enters the window.',
        recurrence:       'Repeat slot',
        frequency:        'Frequency',
        occurrences:      'Number of repetitions',
        effective_probe:  'At the selected slot the mounted probe will be: {probe}',
        effective_none:   'No probe is set on the device at this slot.',
        probe_effective_badge: 'current at slot',
        probe_pending_notice: 'Because the selected probe is not mounted at this slot, the reservation stays pending until an admin confirms it.',
        no_compatible_probes: 'No compatible probes for this device.',
        needs_confirm:    'needs confirmation',
        review_intro:     'Review the details before confirming.',
        submit:           'Confirm reservation',
        created_one:      'Your reservation has been confirmed.',
        created_many:     'You created {n} reservations.',
        created_pending:  'Reservation created and awaiting admin confirmation.',
        no_slots:         'No slots for the selected day.',
        slot_reason: {
            closed:   'Closed',
            occupied: 'Occupied',
            downtime: 'Downtime',
            quota:    'Not enough quota',
        },
        freq: {
            daily:   'Daily',
            weekly:  'Weekly',
            monthly: 'Monthly',
        },
        no_recurrence: 'No repetition',
    },
    device: {
        closed_all_day: 'Closed all day',
        schedule_same: 'Same schedule every day',
        schedule_same_desc: 'The same hours and quotas each day',
        schedule_per_day: 'Schedule per day',
        schedule_per_day_desc: 'Separate hours and quotas for each weekday',
        per_day_hint: 'Each day has its own hours and quotas. An empty day means the device is closed that day. The system rule "weekends do not count towards quota" does not apply to this device – the Saturday and Sunday quotas set here are used.',
        day_closed_all: 'The device is closed all day – add a band to allow bookings.',
        copy_to_weekdays: 'Copy to weekdays',
        copy_to_weekend: 'Copy to weekend',
        copy_to_all: 'Copy to all days',
        close_day: 'Close all day',
        closed_short: 'closed',
        schedule_label: 'Schedule',
        title:          'Devices',
        subtitle:       'NMR device management',
        col_name:       'Device name',
        col_status:     'Status',
        col_color:      'Color',
        col_interval:   'Interval',
        col_probe:      'Current probe',
        col_reservations: 'Reservations',
        info:           'Information',
        set_probe:      'Current probe',
        downtime:       'Downtime',
        interval_min:   '{min} min',
        slot_length:    'Slot length',
        free_window:    'Free reservation window (days)',
        free_window_help: '0 = no limit. Reservations by users starting more than this many days from today await admin confirmation.',
        free_window_unlimited: 'No limit',
        compatible_probes: 'Compatible probes',
        hour_bands:     'Working hours and quotas',
        band_from:      'From',
        band_to:        'To',
        band_open:      'Open',
        band_closed:    'Closed',
        band_cost:      'Quota cost',
        band_order_error: 'Band end must be after its start.',
        band_overlap_error: 'Bands {a} and {b} overlap — adjust the times.',
        add_band:       'Add band',
        free:           'Free',
        info_title:     'Device information',
        set_probe_title: 'Set current probe',
        add_device:     'New device',
        edit_device:    'Edit device',
        delete_confirm: 'Do you really want to delete this device?',
        no_devices:     'No devices',
        status: {
            active:   'Active',
            inactive: 'Inactive',
        },
    },
    downtime: {
        title:          'Downtimes',
        subtitle:       'Planned device downtimes',
        add:            'Add downtime',
        device:         'Device',
        period:         'Period',
        pick_period:    'Select a period',
        time_from:      'From (time)',
        time_to:        'To (time)',
        reason:         'Reason',
        filter_device:  'Device',
        tab_upcoming:   'Upcoming',
        tab_history:    'History',
        empty_upcoming: 'No upcoming downtimes',
        empty_history:  'No recorded downtimes',
        delete_confirm: 'Do you really want to delete this downtime?',
    },
    probe: {
        title:       'Probes',
        subtitle:    'NMR probe catalog',
        col_name:    'Name',
        col_code:    'Code',
        col_type:    'Type',
        add_probe:   'New probe',
        edit_probe:  'Edit probe',
        delete_confirm: 'Do you really want to delete this probe?',
        no_probes:   'No probes',
    },
    probe_type: {
        title:          'Probe types',
        add:            'New probe type',
        edit:           'Edit probe type',
        empty:          'No probe types',
        delete_confirm: 'Do you really want to delete this probe type?',
    },
    user: {
        reporter_hint: 'An analyst sees and exports everyone\'s reports, but cannot book or edit anything.',
        title:        'Users',
        subtitle:     'User management',
        col_user:     'User',
        col_contact:  'Contact',
        col_role:     'Role',
        col_groups:   'Groups',
        col_status:   'Status',
        role:         'Role',
        groups:       'Groups',
        groups_hint:  'A user can be a member of multiple groups.',
        password_edit: 'leave blank to keep unchanged',
        active:       'Active',
        can_view_reports: 'Access to reports',
        can_view_reports_desc: 'The user may view usage reports and the record of completed reservations (all administrators have this automatically).',
        active_label: 'Active',
        inactive_label: 'Disabled',
        add_user:     'New user',
        edit_user:    'Edit user',
        delete_confirm: 'Do you really want to delete this user?',
        no_users:     'No users',
        first_name:   'First name',
        last_name:    'Last name',
    },
    group: {
        title:        'Groups',
        subtitle:     'Research groups',
        leader:       'Leader',
        members:      'Members',
        member_count: '{n} members',
        quotas:       'Quotas',
        members_title: 'Group members',
        add_member:   'Add member',
        member_select: 'Select a user',
        quotas_title: 'Group quotas',
        allocated:    'Allocated quota',
        renewal:      'Renewal',
        add_group:    'New group',
        edit_group:   'Edit group',
        delete_confirm: 'Do you really want to delete this group?',
        no_groups:    'No groups',
        no_members:   'The group has no members',
    },
    client: {
        title:       'Clients and projects',
        subtitle:    'Client and project management',
        tab_clients: 'Clients',
        tab_projects: 'Projects',
        col_name:    'Name',
        col_type:    'Type',
        col_contact: 'Contact',
        contact:     'Contact',
        show_archived: 'Show archived',
        archived:    'Archived',
        archived_hint: 'An archived client is no longer offered in selections.',
        archive:     'Archive',
        unarchive:   'Restore from archive',
        archived_toast:   'Archived',
        unarchived_toast: 'Restored from archive',
        add_client:  'New client',
        edit_client: 'Edit client',
        delete_confirm: 'Do you really want to delete this client?',
        no_clients:  'No clients',
        type: {
            internal: 'Internal',
            external: 'External',
        },
    },
    project: {
        col_name:    'Name',
        col_code:    'Code',
        code:        'Code',
        client:      'Client',
        no_client:   'Internal (no client)',
        groups:      'Groups',
        groups_all:  'All groups',
        groups_help: 'Leave empty to offer the project to every group.',
        groups_all_hint: 'No group selected — the project is available to every group.',
        archived_hint: 'An archived project is no longer offered when booking.',
        add_project: 'New project',
        edit_project: 'Edit project',
        delete_confirm: 'Do you really want to delete this project?',
        no_projects: 'No projects',
    },
    quota: {
        title:        'Quotas',
        subtitle:     'Quota usage overview',
        edit_note:    'Quotas are edited under Groups → Quotas.',
        used:         'Used',
        reserved:     'Reserved',
        free:         'Free',
        allocated:    'Allocated',
        percent_used: '{pct}% used',
        renewal_label: 'Renewal: {renewal}',
        filter_group: 'Group',
        filter_device: 'Device',
        period:          'Period',
        period_current:  'Current period',
        period_month:    'This month',
        period_3m:       'Last 3 months',
        period_6m:       'Last 6 months',
        period_year:     'Last year',
        consumption:  'Usage {used}/{allocated} ({pct}%)',
        no_allocations: 'No allocated quotas',
        no_group_allocations: 'No group allocations for this device.',
        renewal: {
            weekly:  'Weekly',
            monthly: 'Monthly',
            yearly:  'Yearly',
            never:   'No renewal',
        },
    },
    report: {
        tab_overview: 'Overview',
        tab_devices: 'By device',
        tab_clients: 'By client and project',
        tab_groups: 'By group',
        tab_details: 'Detailed reservations',
        clients_hint: 'Usage of all devices by client – click a row for its projects',
        groups_hint: 'Usage of all devices by research group – click a row for its users',
        col_projects: 'Projects',
        col_users: 'Users',
        col_by_device: 'By device',
        no_project: 'No project',
        free_text: 'free text',
        chart_hover_hint: 'Hover a bar for details',
        col_share: 'Share',
        col_count_short: 'Res.',
        kpi_hours: 'Booked hours',
        kpi_reservations: 'Reservations',
        kpi_occupancy: 'Occupancy',
        kpi_occupancy_sub: '{booked} of {open} open hours',
        kpi_users: 'Users',
        kpi_groups: '{n} groups',
        kpi_devices: 'Devices used',
        kpi_devices_sub: 'with at least one reservation',
        summary_title: 'Period summary',
        devices_compare: 'Device comparison',
        occupancy_short: '{pct} % occupancy',
        subtitle_own: 'Usage of your reservations by period and client',
        export_summary: 'Export summary (CSV)',
        export_reservations: 'Export reservations (CSV)',
        csv_device: 'Device',
        csv_kind: 'Type',
        csv_name: 'Name',
        csv_hours: 'Hours',
        csv_count: 'Reservations',
        csv_total: 'Total',
        csv_start: 'Start',
        csv_end: 'End',
        title:          'Reports',
        subtitle:       'Device usage by period and client',
        filter_device:  'Device',
        period:         'Period',
        pick_period:    'Select a period',
        preset_this_week:  'This week',
        preset_this_month: 'This month',
        preset_last_month: 'Last month',
        preset_this_year:  'This year',
        total_hours:    'Total hours',
        total_reservations: 'Reservations',
        by_day:         'Occupancy by day',
        by_day_hint:    'Booked hours per day · click a day to open its detailed reservations',
        day_bucket:     '{day}: {hours}',
        by_group:       'By group',
        col_group:      'Group',
        no_group:       'No group',
        by_client:      'By client',
        col_client:     'Client',
        col_hours:      'Hours',
        col_count:      'Reservations',
        no_client:      'No client',
        no_usage:       'No usage in this period.',
        empty:          'No data for the selected period',
        detail_title:   'Detailed reservations',
        detail_empty:   'No reservations in the selected period',
        detail_day:     'Day',
        detail_all_days: 'All days of the period',
        detail_all_users: 'All users',
        detail_clear:   'Clear filters',
        detail_count:   'Showing {n} of {total}',
        hours_short:        '{h} h',
        minutes_short:      '{m} min',
        hours_minutes_short: '{h} h {m} min',
    },
    notification: {
        title:         'Notifications',
        subtitle_zero: 'You have no unread notifications',
        subtitle_some: 'You have {n} unread notifications',
        mark_all_read: 'Mark all as read',
        mark_unread:   'Mark as unread',
        delete:        'Delete',
        delete_read:   'Delete read',
        delete_read_confirm: 'Delete {n} read notifications? This cannot be undone.',
        deleted_read_toast: 'Read notifications deleted',
        unread_only:   'Unread only',
        no_filtered:   'No notifications for this filter',
        category: {
            all:          'All',
            reservation:  'Reservations',
            probe_change: 'Probe changes',
            feedback:     'Feedback',
            message:      'Messages',
        },
        reply:         'Reply',
        reply_message: 'Your reply',
        reply_placeholder: 'Write a reply …',
        reply_send:    'Send reply',
        reply_sent:    'Reply sent',
        reply_to_person: 'To: {name}',
        reply_to_admins: 'To: administrators',
        compose:       'New notification',
        tab_inbox:     'Inbox',
        tab_sent:      'Sent',
        highlighted:   'Highlighted',
        sender:        'Sender',
        target:        'Recipients',
        sent_to:       'to: {target}',
        no_inbox:      'No notifications',
        no_sent:       'No sent notifications',
        compose_title: 'New notification',
        field_title:   'Title',
        field_message: 'Message',
        field_type:    'Type',
        field_recipients: 'Recipients',
        field_highlighted: 'Highlighted notification',
        recipient_all:    'All users',
        recipient_groups: 'Selected groups',
        recipient_person: 'Specific person',
        select_groups: 'Select groups',
        select_person: 'Select a person',
        sent_toast:    'Notification sent ({n} recipients)',
        type: {
            info:    'Information',
            success: 'Success',
            warning: 'Warning',
            error:   'Error',
            request: 'Request',
        },
    },
    confirmation: {
        title:          'Confirmations',
        subtitle:       'Reservations awaiting admin confirmation',
        empty_title:    'No pending confirmations',
        empty_desc:     'All reservations are confirmed.',
        swap_badge:     'swap',
        reasons:        'Reasons',
        reason: {
            probe_mismatch: 'Probe change',
            outside_window: 'Outside window',
        },
        previous:       'Previous reservation',
        next:           'Next reservation',
        no_probe:       'No probe',
        confirm:        'Confirm',
        reject:         'Reject',
        reject_title:   'Reject reservation',
        reject_confirm: 'Do you really want to reject this reservation? The user will be notified.',
        reject_reason:  'Rejection reason',
        reject_reason_placeholder: 'Optional — the reason is included in the notification sent to the user.',
        confirmed_toast: 'Reservation confirmed',
        rejected_toast: 'Reservation rejected',
    },
    probe_plan: {
        title:          'Probe changes',
        subtitle:       'Probe-change schedule derived from confirmed reservations',
        filter_device:  'Device',
        filter_probe:   'Probe',
        all_probes:     'All probes',
        swap:           'Change',
        empty:          'No scheduled probe changes',
        ready_at:       'Ready from',
        due_at:         'Needed by',
        needed_by:      'Needed by',
        complete:       'Confirm change',
        complete_confirm: 'Confirm that probe {probe} is physically mounted on device {device}? This sets it as the device\'s active probe.',
        completed_toast: 'Probe change confirmed',
        completed_by:   'Completed: {name}, {at}',
        backlog_hint:   'Earlier reservations still need the current probe.',
        period_upcoming: 'Upcoming',
        status: {
            backlog: 'Backlog',
            todo:    'To do',
            overdue: 'Overdue',
            done:    'Done',
        },
    },
    settings: {
        title:        'Settings',
        subtitle:     'Notification settings',
        email_notifications: 'E-mail notifications',
        email_desc:   'Receive notifications by e-mail.',
        system_title:    'System settings',
        system_subtitle: 'Apply to all users',
        edit_window:     'Editing past reservations',
        edit_window_desc: 'How many days after a reservation ends its user may still correct its group, project and note. 0 = not allowed.',
        weekend_free:    'Saturday and Sunday slots do not count towards quota',
        weekend_free_desc: 'Weekend bookings are allowed but consume no group quota. Switch off to count weekends like weekdays.',
        days:            'days',
    },
    profile: {
        title:        'Profile',
        subtitle:     'Your user profile',
        personal_data: 'Personal data',
        change_password: 'Change password',
        current_password: 'Current password',
        new_password: 'New password',
        confirm_password: 'Confirm new password',
        save_password: 'Change password',
        primary_group: 'Primary group',
        logout:       'Log out',
        my_profile:   'My profile',
    },
    time: {
        just_now: 'just now',
        min_ago:  '{n} min ago',
        hour_ago: '{n} h ago',
        yesterday: 'yesterday',
        days_ago: '{n} days ago',
    },
} as const
